import styled from "vue-styled-components";

const PanelItemProps = {
  text: String
};

const PanelItem = styled('div', PanelItemProps)`
    margin-top: 8px;
    margin-bottom: 8px;
    position: static;
    display: block;
    align-items: center;
    padding: 0 10px;
    height: 36px;
    background-color: #fff;
    border: 1px solid #DEE3E6;
    border-radius: 4px;
    transition: background-color 0.2s ease-out;
    &.disabled {
      color: #A5A5A5;
    }
    &.hover, &:hover {
      background: #F4FCFF;
      cursor: ${({ text }) => text == '' ? 'pointer' : 'default'} ;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
      outline: 1px solid var(--primary);
    }
    .tool {
      display: none;
    }
    &.pl-35 {
        padding-left : 35px;
    }

    &:hover {
        background-color: #f4fcff;
        .tool {
            display: block;
            margin-left: 5px;
            .btn {
              padding: 0px;
              border: 0px;
            }
            .option {
              &:hover {
                background-color: #f4fcff;
              }
            }
        }
        .home-icon, .drag-icon {
          color: #373E44 !important;
        }    
        /* .disabled.text-muted {
            display: none;
        } */
    }
    &.bactive.active , .bactive:active{
      .tool {
          display: block;
      }
    }
    .tools-more-menu {
      width: 20px;
      height: 20px;
      padding: 0;
      border-radius: 50%;
      background: transparent;
      border: none;
      text-align: center;
      outline: 1px solid #BDEBF6;
          &:hover {
              outline: 2px solid #BDEBF6;
          }
          &.active{
              outline: 2px solid #24BEE2;
          }
    }
    .popover {
      margin-top: -12px;
      margin-left: 14px;
      width: 150px;
      border: 1px solid #CED4DA;
      border-radius: 4px;
      /* box-shadow: 0px 16px 48px 0px rgb(0 0 0 / 18%); */
      box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.176);
      background: #FFFFFF;
      .arrow {
        display: none;
      }
      .popover-body {
        padding: 10px 0;
        .option {
          color: #373E44;
          padding: 5px 20px;
        }
      }
    }
    /* .bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
        border-width: 0px;
        box-shadow: 0px 16px 48px 0px rgb(0 0 0 / 18%);

    } */
    .home-icon {
      display: none;
      color: #DEE3E6;
      font-size: 16px; 
      width: 16px; 
      height: 16px
    }
    .drag-icon {
      color: #DEE3E6 !important;
      font-size: 16px; 
      width: 16px; 
      height: 16px
    }
    .home {
      .home-icon {
        display: initial;
      }
      .drag-icon {
        display: none;
      }
    }
    .b-icon
    &:hover {
        .option {
          &:hover {
            background-color: #f4fcff;
          }
        }
        .home {
          .home-icon {
            display: none;
          }
          .drag-icon {
            display: initial;
          }
        }
        background-color: #F8F9FA;   
        .disabled.text-muted {
            display: none;
        }
    }
`;

const NestedWrapper = styled.div`
 .nestable-item .nestable-item-content .handler {
  &::before {
      transition: all 0.2s ease;
      content: '';
      height: 1px;
      width: 15px;
      background-color: #DFDFDF;
      position: absolute;
      top: 18px;
      left: -15px;
      margin: auto;
    }
    &::after {
        transition: all 0.2s ease;
        content: '';
        width: 1px;
        height: calc(100% + 10px);
        background-color: #DFDFDF;
        position: absolute;
        top: 1px;
        bottom: 0;
        left: -15px;
        margin-top: -10px;
    }
 }
 .nestable-item:last-child  > .nestable-item-content .handler{
    &::after {
      transition: all 0.1s ease;
      height: 28px;
    }
 }
 .nestable-group > .nestable-item > .nestable-item-content .handler{
    &::before {
      display: none;
    }
    &::after {
      display: none;
    }
  }
  .nestable.pos-unset {
    position: unset;
    .nestable-item {
      position: unset;
      .nestable-item-content .handler::before,
      .nestable-item-content .handler::after {
        display: none;
      }
    }
  }
`

const WrapperEmpty = styled.div`
  margin-top: 9px;
  margin-bottom: 9px;
  position: relative;
  display: block;
  padding: .5rem .75rem .5rem .6rem;
  background-color: #fff;
  border: 1px solid var(--line);
  border-radius: 4px;
`;

export {
  WrapperEmpty,
  PanelItem,
  NestedWrapper
}